module.exports = __webpack_public_path__ + "img/alarm.fa5322e5.png";